import { Box, styled } from '@mui/material'

export const StyledLogoBox = styled(Box)(({ theme }) => ({
  width: 110,
  '& path': {
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.standard,
    }),
    fill: theme.palette.primary.main,
  },
  [theme.breakpoints.up('md')]: {
    width: 120,
  },
  [theme.breakpoints.up(1000)]: {
    width: 134,
  },
}))
